export default __webpack_public_path__ + "static/media/check-hovered.46f8927b.svg";